import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Drawer from 'material-ui/Drawer';
import { Config } from 'constants/ThemeColors';
import SidenavContent from './SidenavContent';
import UserInfo from 'components/UserInfo';
import { COLLAPSED_DRAWER, FIXED_DRAWER } from 'constants/ActionTypes';
import { updateWindowWidth } from 'actions/Setting';

import { toastr } from 'react-redux-toastr'

import { clearToasters } from '../../actions/toaster'

class SideNav extends React.PureComponent {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        window.addEventListener("resize", () => {
            this.props.updateWindowWidth($(window).width())
        });
    }

    render() {
        const { navCollapsed, drawerType, width, toastermsg, loginUser } = this.props;
        const drawerStyle = drawerType.includes(FIXED_DRAWER) ? "d-xl-flex" : drawerType.includes(COLLAPSED_DRAWER) ? "" : "d-flex";
        let type = "permanent";
        if (drawerType.includes(COLLAPSED_DRAWER) || (drawerType.includes(FIXED_DRAWER) && width < 1200)) {
            type = "temporary";
        }
        // console.log('SideNav index ', this.props)

        //Show toaster message based on messageType
        if (toastermsg.message) {
            toastermsg.message = toastermsg.message.split('~')[0];
            if (toastermsg.messageType == 'Warning')
                toastr.warning(toastermsg.message)
            if (toastermsg.messageType == 'Success')
                toastr.success(toastermsg.message);
            if (toastermsg.messageType == 'Error')
                toastr.error(JSON.stringify(toastermsg.message))
            this.props.clearToasters();
        }
        if (!loginUser.data)
            this.props.history.push('/login');

        return (
            <div className={`app-sidebar d-none ${drawerStyle}`}>
                <Drawer className="app-sidebar-content"
                    variant={type}
                    open={type.includes("temporary") ? navCollapsed : true}
                    onClose={this.props.onToggleCollapsedNav}
                    classes={{ paper: 'side-nav', }}
                >
                    <UserInfo loginUser={this.props.loginUser} />
                    <SidenavContent loginUser={this.props.loginUser} getCustomer={this.props.getCustomer} />
                </Drawer>
            </div>
        );
    }

}

const mapStateToProps = ({ settings, toastermsg, loginUser, getCustomer }) => {
    const { navCollapsed, drawerType, width } = settings;
    return { navCollapsed, drawerType, width, toastermsg, loginUser, getCustomer }
};

export default withRouter(connect(mapStateToProps, { updateWindowWidth, clearToasters })(SideNav));




// WEBPACK FOOTER //
// ./containers/SideNav/index.js